module.exports = __webpack_public_path__ + "img/conference-logo.3f29c050.png";